import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LocationOnOutlined, PhoneOutlined, CheckCircleOutline } from '@mui/icons-material';
import '../styles/common.css';
import '../styles/SeoPages.css';
import weddingHeroObj from '../images/wedding-hero.png'; // Importing as object just in case, but standard is path

const WeddingJewelleryPage = () => {
    useEffect(() => {
        document.title = "Wedding Jewellery in Rajasthan | Bridal Gold Jewellery – MAB Jewels";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute("content", "Explore bridal and wedding jewellery in Rajasthan. Traditional gold jewellery for weddings by trusted jewellers.");
        }
    }, []);

    return (
        <div className="page-container seo-page">
            <div className="seo-content-wrapper">
                <h1>Wedding Jewellery in Rajasthan</h1>

                {/* 1. Visual Section (Hero Image) */}
                <div className="seo-hero-image-container" style={{ position: 'relative' }}>
                    <img
                        src={weddingHeroObj}
                        alt="Happy bride wearing MAB Jewels Gold Jewellery"
                        className="seo-hero-image"
                        style={{ width: '100%', borderRadius: '12px', marginBottom: '30px', boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }}
                    />
                    {/* Wedding Mode CTA Overlay */}
                    <div className="wedding-mode-overlay" style={{
                        position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)',
                        background: 'rgba(255,255,255,0.95)', padding: '20px 30px', borderRadius: '50px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.2)', textAlign: 'center', minWidth: '300px'
                    }}>
                        <h3 style={{ margin: '0 0 10px 0', fontFamily: 'Playfair Display', color: '#1a1a1a' }}>Planning a Wedding?</h3>
                        <a href="https://wa.me/919414817620?text=I%20am%20looking%20for%20Bridal%20Jewellery%20consultation"
                            target="_blank" rel="noreferrer"
                            style={{
                                display: 'inline-block', background: '#d4af37', color: '#fff',
                                padding: '10px 25px', borderRadius: '30px', textDecoration: 'none', fontWeight: 'bold'
                            }}>
                            📞 Book Free Consultation
                        </a>
                    </div>
                </div>

                <p className="seo-intro">
                    Wedding jewellery is a symbol of tradition, beauty, and lifelong memories.
                    MAB Jewels specializes in elegant <strong>wedding jewellery in Jodhpur</strong> and across Rajasthan, crafting pieces that tell your unique story.
                </p>

                {/* 2. Visual Category Grid */}
                <h2>Explore Bridal Collection</h2>
                <div className="wedding-category-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px' }}>
                    <Link to="/jewellery?type=set,necklace&tag=wedding" className="wedding-cat-card" style={{ display: 'block', padding: '20px', background: '#fff', border: '1px solid #eee', borderRadius: '10px', textAlign: 'center', textDecoration: 'none', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                        <span style={{ fontSize: '2rem' }}>👰</span>
                        <h3 style={{ margin: '10px 0 5px', color: '#333' }}>Bridal Sets</h3>
                        <p style={{ color: '#888', fontSize: '0.9rem' }}>Complete Look</p>
                    </Link>
                    <Link to="/jewellery?type=bangle,bracelet" className="wedding-cat-card" style={{ display: 'block', padding: '20px', background: '#fff', border: '1px solid #eee', borderRadius: '10px', textAlign: 'center', textDecoration: 'none', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                        <span style={{ fontSize: '2rem' }}>✨</span>
                        <h3 style={{ margin: '10px 0 5px', color: '#333' }}>Bangles & Choodas</h3>
                        <p style={{ color: '#888', fontSize: '0.9rem' }}>Traditional Charm</p>
                    </Link>
                    <Link to="/jewellery?type=earring,top" className="wedding-cat-card" style={{ display: 'block', padding: '20px', background: '#fff', border: '1px solid #eee', borderRadius: '10px', textAlign: 'center', textDecoration: 'none', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                        <span style={{ fontSize: '2rem' }}>👂</span>
                        <h3 style={{ margin: '10px 0 5px', color: '#333' }}>Heavy Earrings</h3>
                        <p style={{ color: '#888', fontSize: '0.9rem' }}>Statement Pieces</p>
                    </Link>
                </div>

                {/* 3. Why Choose Section */}
                <h2>Why Brides Trust MAB Jewels</h2>
                <ul className="seo-check-list">
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> BIS Hallmark Certified Gold</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> Handmade Rajasthani Designs</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> Custom Bridal Jewellery</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> Transparent Pricing</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> Trusted by Families Across Rajasthan</li>
                </ul>

                <h2>Trusted Wedding Jeweller in Rajasthan</h2>
                <p>
                    With a strong legacy in Rajasthan, MAB Jewels is known for quality, purity, and customer trust.
                    Whether you are looking for <strong>gold jewellery for weddings in Rajasthan</strong> or a specific custom piece, we are here to help.
                </p>

                {/* 5. FAQ Section */}
                <h2>Frequently Asked Questions</h2>
                <div className="seo-faq-section">
                    <div className="seo-faq-item">
                        <h4>Q: Do you provide custom bridal jewellery?</h4>
                        <p>Yes, we specialize in custom wedding jewellery designs tailored to your budget and tradition. We work closely with brides to create their dream set.</p>
                    </div>
                    <div className="seo-faq-item">
                        <h4>Q: Is your gold BIS hallmarked?</h4>
                        <p>Yes, all our gold jewellery is BIS hallmarked, ensuring purity and trust for your big day.</p>
                    </div>
                    <div className="seo-faq-item">
                        <h4>Q: Do you serve customers outside Jodhpur?</h4>
                        <p>Yes, we serve customers across Rajasthan. Families from all over the state trust MAB Jewels for their wedding purchases.</p>
                    </div>
                </div>

                {/* Local SEO Boost */}
                <div className="local-seo-box">
                    <h3>Contact MAB Jewels</h3>
                    <div className="seo-contact-row">
                        <LocationOnOutlined sx={{ color: '#d4af37', mr: 1 }} />
                        <span>Rajasthan, India</span>
                    </div>
                    <div className="seo-contact-row">
                        <PhoneOutlined sx={{ color: '#d4af37', mr: 1 }} />
                        <span>+91 94148 17620</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeddingJewelleryPage;
